import { render } from "./SummaryVuzSvodView.vue?vue&type=template&id=8b88cd7c&scoped=true"
import script from "./SummaryVuzSvodView.vue?vue&type=script&lang=js"
export * from "./SummaryVuzSvodView.vue?vue&type=script&lang=js"

import "./SummaryVuzSvodView.vue?vue&type=style&index=0&id=8b88cd7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b88cd7c"]])

export default __exports__